import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaTimes } from 'react-icons/fa';
import '../assets/css/WhatsAppFloat.css';

const WhatsAppFloat = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    // Show button after page loads
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    // Show tooltip after a few seconds
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(true);
      // Hide tooltip after 5 seconds
      setTimeout(() => setShowTooltip(false), 5000);
    }, 5000);

    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  const handleWhatsAppClick = () => {
    // Design Craft Office Furniture WhatsApp number
    const phoneNumber = '971501900982';
    const message = encodeURIComponent('Hello! I am interested in your office furniture. Can you please provide more information?');
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;
    
    // Open WhatsApp in new tab
    window.open(whatsappUrl, '_blank');
    
    // Hide tooltip after click
    setShowTooltip(false);
  };

  const handleTooltipClose = (e) => {
    e.stopPropagation();
    setShowTooltip(false);
  };

  if (!isVisible) return null;

  return (
    <div className="whatsapp-float-container">
      {/* Tooltip */}
      {showTooltip && (
        <div className="whatsapp-tooltip">
          <button 
            className="tooltip-close"
            onClick={handleTooltipClose}
            aria-label="Close tooltip"
          >
            <FaTimes />
          </button>
          <div className="tooltip-content">
            <h4>Need Help?</h4>
            <p>Chat with us on WhatsApp for instant support!</p>
            <small>Design Craft Office Furniture</small>
          </div>
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        className="whatsapp-float-btn"
        id="whatsapp-btn"
        onClick={handleWhatsAppClick}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        aria-label="Chat on WhatsApp"
        title="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="whatsapp-icon" />
        <div className="pulse-ring"></div>
        <div className="pulse-ring-2"></div>
      </button>

      {/* Online Status */}
      <div className="online-status">
        <span className="status-dot"></span>
        <span className="status-text">Online</span>
      </div>
    </div>
  );
};

export default WhatsAppFloat;